<script setup lang="tsx">
import http from '@/services/http'
import { ref } from 'vue'
import logo from '@/assets/images/id-kaart.svg'

const emit = defineEmits(['success'])
const isBusy = ref(false)
const error = ref('')

async function login() {
	error.value = ''
	isBusy.value = true
	let auth: any

	try {
		const aw = window as any
		auth = await aw.webeidAuthenticate()
	} catch (e: any) {
		error.value = e.message
		isBusy.value = false
		return
	}

	const request = {
		cert: auth.unverifiedCertificate,
		signature: auth.signature,
	}

	try {
		const { status } = await http.post('idlogin', request)
		if (status == 200) emit('success')
	} catch {
		// ignore
	}

	isBusy.value = false
}
</script>

<template>
	<div class="row">
		<div class="col">
			<button id="idlogin-btn" :disabled="isBusy" @click="login">
				<img :src="logo" :alt="$t('login')" height="100vh" />
			</button>
		</div>
	</div>
	<div v-if="error" class="row mt-3">
		<div class="col">
			<div class="alert alert-danger">
				{{ error }}
			</div>
		</div>
	</div>
</template>

<style lang="sass" scoped>
button
  border: 0
  background: transparent

  &:not(:disabled):hover
    opacity: .88
  &:is(:disabled)
    opacity: .4
    cursor: wait
  img
    pointer-events: none
</style>
